import React, { useCallback, useEffect, useState } from "react";
import Header from "../Navbar/page";
import { Link, useNavigate } from "react-router-dom";
import Api from "../Api/Api";
import { ToastContainer, toast } from "react-toastify";
import SideNavbar from "../Navbar/sideNav/page";
import FooterSection from "../footer/page";
import { RingLoader } from "react-spinners";
// import {} from "../Navbar/page/"

function Page() {
  const [userbalance, setUserbalance] = useState({});
  const [fademodel, setfademodel] = useState(false);
  const [withdrrawalAmount, setwithdrrawalAmount] = useState("");
  const [Updateresponse, setUpdateresponse] = useState();
  const [valiadtionData, setvaliadtionData] = useState(true);
  const [buttonConfirmation, setbuttonConfirmation] = useState(true);
  const [loading, setLoading] = useState(false);
  const UserIdclient = localStorage.getItem("UserIdclient");
  const clientid = localStorage.getItem("UserIdclient");
  const navigate = useNavigate();
  const handlepopupFreeopen = async () => {
    const amountDatavalidation = withdrrawalAmount === "" || isNaN(withdrrawalAmount) || withdrrawalAmount<=0;

    if (amountDatavalidation) {
      setvaliadtionData(false);
      toast("Please enter a valid amount", { type: "error" });
      return;
    }

    // Check if withdrawal amount exceeds balance
    if (Number(withdrrawalAmount) > Number(userBalanceData)) {
      setvaliadtionData(false);
      toast("Entered amount exceeds available balance", { type: "error" });
      return;
    }

    setfademodel(true);
  };

  const submitData = async () => {
    setbuttonConfirmation(false);

    // Extra safeguard validation before API call
    if (Number(withdrrawalAmount) > Number(userBalanceData)) {
      toast("Entered amount exceeds available balance", { type: "error" });
      setbuttonConfirmation(true);
      return;
    } 
    try {
      const response = await Api.post("/user/transferPoints", {
        userid: UserIdclient,
        transferAmount: Number(withdrrawalAmount),
      });
      
      setUpdateresponse(response.data.message);
      toast(response.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      setwithdrrawalAmount("");
      window.updateBalance += 1;
      navigate("/transaction-history");
    } catch (error) {
      toast(error.response?.data?.message || "Something went wrong", {
        type: "error",
      });
    }

    setfademodel(false);
    setbuttonConfirmation(true);
  };


  // const defineData=1;

  // const undefineData=defineData ?? "hello undefine" ;
  // console.log("undddd",undefineData)

  const Getbalance = useCallback(async () => {
    setLoading(true)
    const formData = new FormData();
    formData.append("userid", 1);
    try {
      const response = await Api.get(`/user/getUser?userid=${UserIdclient}`);
      // console.log("Dattataat---->", response.data.result);
      setUserbalance(response.data.result);
    } catch (error) {
      console.log(error);
    }
    setLoading(false)
  }, [withdrrawalAmount]);

  const userBalanceData = userbalance.balance ?? "N/A";

  useEffect(() => {
    Getbalance();
  }, [Updateresponse]);

  useEffect(() => {
    Getbalance();
  }, []);

  return (
    <>
      <ToastContainer />
      <Header />

      {/* <div className="layout has-sidebar fixed-sidebar fixed-header">
        <SideNavbar />
        <div className="layout">
          <main className="content">
            <Header datauser={Updateresponse} /> */}
      {loading ? (
        <div
          className="d-flex justify-content-center"
          style={{ marginTop: "30%", marginBottom: "20%" }}
        >
          {/* <Loader/> */}
          <RingLoader color="rgb(50 92 213)" size="100" />
        </div>
      ) : (
        <>
          {/* <Header /> */}
          <div className="body-background">
            <section className="banner-section inner-banner position-relative about">
              <div className="shape-area">
                <img
                  src="/assets/images/abs-items/bubble.png"
                  className="shape-1"
                  alt="icon"
                />
                <img
                  src="/assets/images/abs-items/ellipse-7.png"
                  className="shape-2"
                  alt="icon"
                />
              </div>
              <div className="container position-relative">
                <div style={{ marginTop: "9%", cursor: "pointer" }}>
                  <i class="fa fa-arrow-left" onClick={() => navigate(-1)}></i>
                </div>
                <div className="banner-content row justify-content-between">
                  <div className="col-lg-6 col-md-10">
                    <div className="main-content">
                      <h2 className="visible-slowly-bottom display-four mb-6">
                        Wallet
                      </h2>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-10 d-grid align-items-end justify-content-end">
                    <div className="breadcrumb-area position-absolute end-0 bottom-0">
                      <nav aria-label="breadcrumb">
                        <ol className="breadcrumb m-0 py-3 px-8 fs-six d-flex align-items-end justify-content-end">
                          <li className="breadcrumb-item p-0 m-0">
                            <Link to="/">Home</Link>
                          </li>
                          <li
                            className="breadcrumb-item active"
                            aria-current="page"
                          >
                            Wallet
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <div className="authority bettor-ranking">
              <div className="container">
                <form>
                  <div className="d-grid wallet" style={{ width: "810px" }}>
                    <div className="balance-statics">
                      <div className="single-statics">
                        <div className="part-icon">
                          <img src="/assets/images/image-2.png" alt="" />
                        </div>

                        <div className="form-group">
                          <label>
                            Account Balance In Your Weshareabundance Available
                            Cash Wallet
                          </label>
                          <input
                            type="text"
                            // placeholder={`$${userbalance.balance}`}
                            placeholder={userBalanceData}
                            // value={`$${userbalance.balance}`}
                            className="detail-btn"
                            readOnly
                          />
                        </div>
                      </div>
                    </div>

                    <div className="balance-statics">
                      <div className="single-statics">
                        <div className="part-icon">
                          <img src="/assets/images/image-4.png" alt="" />
                        </div>

                        <div className="form-group">
                          <label>Withdrawal Balance</label>
                          <input
                            type="number"
                            placeholder="Please enter the amount you want to transfer here from your ACW Wallet"
                            //   value="$50"
                            value={withdrrawalAmount}
                            onChange={(e) => {
                              e.preventDefault();
                              setwithdrrawalAmount(e.target.value);
                            }}
                            className="detail-btn"
                            style={{ cursor: "text" }}
                          />
                          <h6
                            style={{
                              color: "red",
                              float: "right",
                              marginTop: "5px",
                            }}
                          >
                            {valiadtionData ? "" : "Please enter amount"}
                          </h6>
                        </div>
                      </div>
                    </div>

                    {/* <div className="balance-statics">
                        <div className="single-statics">
                          <div className="part-icon">
                            <img src="/assets/images/image-5.png" alt="" />
                          </div>

                          <div className="form-group">
                            <label>Payment Method</label>
                            <input
                              type="text"
                              placeholder=""
                              value="Transfer from e-wallet"
                              className="detail-btn"
                              readOnly
                            />
                          </div>
                        </div>
                      </div> */}

                    <div className="btn-area alt-bg connect text-center">
                      <button
                        className="box-style btn-box d-center"
                        // style={{ x: 129, y: 42 }}
                        // onClick={submitData}
                        // onClick={handlepopupFreeopen}
                        onClick={(e) => {
                          e.preventDefault(); // Prevent default button behavior
                          handlepopupFreeopen();
                        }}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <FooterSection />
        </>
      )}
      {/* <div className="layout has-sidebar fixed-sidebar fixed-header"> */}

      {/* </div> */}
      {/* </main> */}
      {/* </div> */}

      <div
        className="modal fade show"
        id="exampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        style={{ display: fademodel ? "block" : "none", paddingTop: "190px" }}
      >
        <div className="modal-dialog">
          <div className="modal-content" style={{ backgroundColor: "#b6b8dc" }}>
            <div className="modal-body">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setfademodel(false)}
              ></button>

              <div className="logo poup">
                {/* <Link to='/'><img src="/assets/images/logo-text.png" className="logo-text d-xxl-block  " alt="logo-text" /></Link> */}
                <h4
                  style={{
                    color: "white",
                    fontWeight: "bold",
                    marginTop: "20px",
                  }}
                >
                  Do you want to transfer the amount from your ACW Wallet to
                  this game's wallet
                </h4>
              </div>

              <div className="d-flex justify-content-center align-items-center">
                <div
                  className="btn-area alt-bg mx-3"
                  style={{ marginTop: "20px" }}
                >
                  {buttonConfirmation ? (
                    <a
                      onClick={() => {
                        submitData();
                      }}
                      className="box-style btn-box d-center"
                    >
                      Confirm
                    </a>
                  ) : (
                    <a className="box-style btn-box d-center">Confirm .....</a>
                  )}
                </div>
                <div className="btn-area alt-bg border-line">
                  <a
                    onClick={() => setfademodel(false)}
                    className="box-style btn-box d-center"
                  >
                    Cancel
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}
    </>
  );
}

export default Page;
